import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiMomentItemsByMomentVariables = Types.Exact<{
  momentId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiMomentItemsByMoment = { moment: { totalItems: number, page: number, totalPages: number, items: Array<{ id: number, momentId: number, position: number, contractAddress: Address, tokenId: number | null, inventoryItem: { __typename: 'DropCollection', slug: string, nftCount: number, chainId: ChainId, earlyAccessStartTime: string | null, generalAvailabilityStartTime: string | null, contractType: Types.ApiContractType, isRevealed: boolean | null, contractAddress: Address, saleType: Types.ApiCollectionSaleType | null, clearingPrice: number | null, dropName: string, dropStatus: Types.ApiDropAvailabilityStatus, dropId: string, dropMintPrice: number | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null } | { __typename: 'EditionCollection', nftCount: number, chainId: ChainId, slug: string, assetUrl: string | null, contractAddress: Address, mimeType: string | null, contractType: Types.ApiContractType, editionName: string, editionId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } } | { __typename: 'MarketNft', chainId: ChainId, saleStartsAt: string | null, marketNftName: string | null, marketNftId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'SoldNft', chainId: ChainId, soldNftName: string | null, soldNftId: string, sale: { amount: number, date: string }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } }> } };



export const ApiMomentItemsByMomentDocument = /*#__PURE__*/ `
    query MomentItemsByMoment($momentId: Int!, $page: Int, $perPage: Int) {
  moment: momentItemsByMoment(momentId: $momentId, page: $page, perPage: $perPage) {
    totalItems
    page
    totalPages
    items {
      id
      momentId
      position
      contractAddress
      tokenId
      inventoryItem {
        __typename
        ... on MarketNft {
          chainId
          marketNftName: name
          marketNftId: id
          creator {
            ...UserLightFragment
          }
          saleStartsAt
          activeAuction {
            duration
            id
            reservePrice
            state
            highestBid {
              amount
              bidder {
                ...UserLightFragment
              }
            }
            expiryDate
          }
          activeBuyNow {
            amount
          }
          activeOffer {
            amount
            expiryDate
          }
          media {
            ...MediaFragment
          }
        }
        ... on SoldNft {
          chainId
          soldNftName: name
          soldNftId: id
          sale {
            amount
            date
          }
          media {
            ...MediaFragment
          }
          creator {
            ...UserLightFragment
          }
        }
        ... on DropCollection {
          dropName: name
          dropStatus: availabilityStatus
          dropId: id
          slug
          nftCount
          chainId
          earlyAccessStartTime
          generalAvailabilityStartTime
          contractType
          isRevealed
          media {
            ...MediaFragment
          }
          contractAddress
          dropMintPrice: mintPrice
          saleType
          clearingPrice
          creator {
            ...UserLightFragment
          }
          saleConfiguration {
            ...DropSaleConfigurationFragment
          }
        }
        ... on EditionCollection {
          editionName: name
          editionId: id
          nftCount
          chainId
          slug
          assetUrl
          contractAddress
          mimeType
          contractType
          creator {
            ...UserLightFragment
          }
          editionSale: saleConfiguration {
            ...EditionSaleConfigurationFragment
          }
        }
      }
    }
  }
}
    ${UserLightFragment}
${MediaFragment}
${DropSaleConfigurationFragment}
${EditionSaleConfigurationFragment}`;

export const useMomentItemsByMoment = <
      TData = ApiMomentItemsByMoment,
      TError = ClientError
    >(
      variables: ApiMomentItemsByMomentVariables,
      options?: Omit<UseQueryOptions<ApiMomentItemsByMoment, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiMomentItemsByMoment, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiMomentItemsByMoment, TError, TData>(
      {
    queryKey: ['MomentItemsByMoment', variables],
    queryFn: apiFetcher<ApiMomentItemsByMoment, ApiMomentItemsByMomentVariables>(ApiMomentItemsByMomentDocument, variables),
    ...options
  }
    )};

useMomentItemsByMoment.getKey = (variables: ApiMomentItemsByMomentVariables) => ['MomentItemsByMoment', variables];

export const useInfiniteMomentItemsByMoment = <
      TData = InfiniteData<ApiMomentItemsByMoment>,
      TError = ClientError
    >(
      variables: ApiMomentItemsByMomentVariables,
      options: Omit<UseInfiniteQueryOptions<ApiMomentItemsByMoment, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiMomentItemsByMoment, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiMomentItemsByMoment, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MomentItemsByMoment.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiMomentItemsByMoment, ApiMomentItemsByMomentVariables>(ApiMomentItemsByMomentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMomentItemsByMoment.getKey = (variables: ApiMomentItemsByMomentVariables) => ['MomentItemsByMoment.infinite', variables];


useMomentItemsByMoment.fetcher = (variables: ApiMomentItemsByMomentVariables, options?: RequestInit['headers']) => apiFetcher<ApiMomentItemsByMoment, ApiMomentItemsByMomentVariables>(ApiMomentItemsByMomentDocument, variables, options);
